'use client';
import { createProps, splitProps } from '@chakra-ui/utils';

const fieldProps = createProps()([
  "aria-describedby",
  "disabled",
  "id",
  "isDisabled",
  "isInvalid",
  "isReadOnly",
  "isRequired",
  "onBlur",
  "onFocus",
  "readOnly",
  "required"
]);
const splitFieldProps = (props) => splitProps(props, fieldProps);

export { fieldProps, splitFieldProps };
